module.exports = __webpack_public_path__ + "img/3.236ceee2.png";